import { Button, Dialog, IconButton, PaperProps } from '@mui/material'
import type { CellFailureProps, CellSuccessProps } from '@cedarjs/web'
import { useMutation } from '@cedarjs/web'
import { useDateStore } from "src/lib/store"
import type {
  FindEditReviewCommentQuery,
} from 'types/graphql'
import { UpdateReviewCommentInput } from 'types/graphql'
import { t } from "i18next";
import { toast } from "@cedarjs/web/toast"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faComment, faEdit, faReply, faWeight } from "@fortawesome/free-solid-svg-icons"
import ReviewCommentForm from "../ReviewCommentForm/ReviewCommentForm"
import { useAuth } from "src/auth"
import { hasResourcePermission } from "src/lib/roles"

const EditButton = ({reviewComment, iconOnly, onClick, disabled = false}) => {
  return (<IconButton onClick={onClick} disabled={disabled} size="small">
          <FontAwesomeIcon icon={reviewComment ? faEdit : faComment} />
      </IconButton>
  )
}
const ReplyButton = ({reviewComment, iconOnly, onClick, disabled = false}) => {
    return (<IconButton onClick={onClick} disabled={disabled} size="small">
            <FontAwesomeIcon icon={faReply}/>
        </IconButton>
    )
}
/**
 * Used to remove the wrapping paper component, as the subcells already have this
 * @param props 
 * @returns 
 */
function DivComponent(props: PaperProps) {
  return (
      <div {...props}></div>
  );
}


const CREATE_REVIEW_COMMENT = gql`
  mutation CreateReviewCommentNewMutation($input: CreateReviewCommentInput!) {
    createReviewComment(input: $input) {
      id
      createdAt
      createdBy
    }
  }
`
const UPDATE_REVIEW_COMMENT = gql`
  mutation UpdateReviewCommentNewMutation($id: Int!, $input: UpdateReviewCommentInput!) {
    updateReviewComment(id: $id, input: $input) {
      id
      createdAt
      createdBy
    }
  }
`

const ReviewComment = (props) => {

  const [createReviewComment] = useMutation(CREATE_REVIEW_COMMENT, { onError(error) { toast.error(error.message) } })
  const [updateReviewComment] = useMutation(UPDATE_REVIEW_COMMENT, { onError(error) { toast.error(error.message) } })
  const { hasRole } = useAuth()

  if(!hasResourcePermission(hasRole, "ReviewComment", "create"))
    return;

  const onSave = (
    input: UpdateReviewCommentInput,
    id?: FindEditReviewCommentQuery['review']['id']
  ) => {
    if(id)
      return updateReviewComment({ variables: { id, input }, refetchQueries: ["FindReviewsQuery", 'FindReviewsSiteQuery', 'TankInfosQuery', 'BatchInfosQuery']})
    else
      return createReviewComment({ variables: { input }, refetchQueries: ["FindReviewsQuery", 'FindReviewsSiteQuery', 'TankInfosQuery', 'BatchInfosQuery']})
  }
  if(props.parent){
    if(!props.isInline)
      return <ReplyReviewCommentDialog {...props} onSave={onSave}/>
    else
      return <ReviewCommentInline review={props.parent} {...props} onSave={onSave}/>
  }
  else if(!props.isInline)
    return <ReviewCommentDialog {...props} onSave={onSave}/>
  else 
    return <ReviewCommentInline {...props} onSave={onSave}/>
}
const ReviewCommentInline = ({ review, parent, onSave, className = "", iconOnly = false, isInline = false }) => {

  return (
    <div className={className}>
      <ReviewCommentForm
        review={review}
        onSave={onSave}
        isInline
      />
    </div>
  )
}
const ReviewCommentDialog = ({ review, parent, reviewComment, onSave, className = "", iconOnly = false, isInline = false }) => {

  const [open, setOpen] = React.useState(false);

  return (
    <div className={className}>
      <EditButton iconOnly={iconOnly} reviewComment={reviewComment} onClick={() => setOpen(!open)}/>

      <Dialog open={open} onClose={() => setOpen(!open)} 
        //https://stackoverflow.com/a/60436717/1437016 only could prevents bubbling, but stopPropagation ensures it
        onClick={(e)=>{e.stopPropagation()}} 
        PaperComponent={DivComponent}>
        <ReviewCommentForm
          review={review}
          reviewComment={reviewComment}
          onSave={onSave}
        />
      </Dialog>
    </div>
  )
}
const ReplyReviewCommentDialog = ({ review, parent, reviewComment, onSave, className = "", iconOnly = false, isInline = false }) => {

  const [open, setOpen] = React.useState(false);

  return (
    <div className={className}>
      <ReplyButton iconOnly={iconOnly} reviewComment={reviewComment} onClick={() => setOpen(!open)}/>

      <Dialog open={open} onClose={() => setOpen(!open)} 
        //https://stackoverflow.com/a/60436717/1437016 only could prevents bubbling, but stopPropagation ensures it
        onClick={(e)=>{e.stopPropagation()}} 
        PaperComponent={DivComponent}>
        <ReviewCommentForm
          parent={parent}
          onSave={onSave}
        />
      </Dialog>
    </div>
  )
}

export default ReviewComment